import React, { Component } from "react";
// React-bootstrap
import {
  Button,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
} from "react-bootstrap";
// Firebase
import { auth } from "../../firebase/index";
import "../../routes/app";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";

function FieldGroup({ id, label, help, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
}

class ForgotPasswordModal extends Component {
  constructor(props) {
    super(props);

    // Handlers for displaying the add user form
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    // Handlers for displaying start and end time
    this.handleDisplay = this.handleDisplay.bind(this);
    this.handleHide = this.handleHide.bind(this);

    // Handlers for submitting to firebase
    this.onSubmit = this.onSubmit.bind(this);

    // Handler for Force Update
    this.forceUpdateHandler = this.forceUpdateHandler.bind(this);

    this.state = {
      // Displaying the add user form
      show: false,
      hidden: true,
      returnMessage: "",
      email: "",
      name: "",
      _notificationSystem: null,
    };
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  // Force Update Handler
  forceUpdateHandler() {
    this.forceUpdate();
  }

  // Handlers for displaying the add user modal
  handleClose() {
    this.setState({ show: false, returnMessage: "" });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleHide() {
    this.setState({ hidden: true });
    this.forceUpdateHandler();
  }

  handleDisplay() {
    this.setState({ hidden: false });
    this.forceUpdateHandler();
  }

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-check"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  onSubmit(formEvent) {
    formEvent.preventDefault();
    var email = this.state.email;
    // fire.database().ref('userFriendList').child(auth.currentUser.uid).child(name).set(email)

    auth
      .sendPasswordResetEmail(email)
      .then(() => {
        this.showNotification(
          "A message has been sent to you by email with instructions on how to reset your password.",
          "success",
          "tc",
          5
        );
        this.setState({
          returnMessage:
            "Please check your email address for reset instructions",
        });
      })
      .catch((error) => {
        this.setState({
          returnMessage: error.message,
        });
      });

    // window.location.reload()
  }
  render() {
    const { email } = this.state;
    const isInvalid = email === "";

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <div
          style={{
            textAlign: "center",
            // marginBottom: "10px",
            // marginTop: "-15px"
          }}
        >
          <a
            style={{
              color: "black",
              textDecoration: "underline",
              cursor: "pointer",
              fontWeight: "600",
            }}
            onClick={this.handleShow}
          >
            Forgot Password?
          </a>
        </div>

        {/* <Button
                    className="btn btn-primary btn-fill"
                    style={{ width: "100%" }}
                    onClick={this.handleShow}
                >
                    Select Users
                </Button> */}

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title style={{ textAlign: "center" }}>
              Reset Password
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <form onSubmit={this.onSubmit}>
              <FieldGroup
                id="formControlsEmail"
                type="email"
                label="Email address"
                placeholder="name@example.com"
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
              />
              <br />
              <Button
                disabled={isInvalid}
                className="loginsignupbutton"
                style={{ width: "100%" }}
                type="submit"
              >
                Reset Password
              </Button>
            </form>
            <br />
            <div>
              <p style={{ textAlign: "center", marginBottom: "0px" }}>
                {this.state.returnMessage}
              </p>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
export default ForgotPasswordModal;
